import React, { Component } from 'react';
import FractionField from '../NewOptionFields/FractionField';
import OptionField from '../NewOptionFields/OptionField';
import { getQuoteColor } from '../QuoteObjectExtensions.ts';

class CoupledShadeTable extends Component {
	constructor(props) {
		super(props);

		this.changeBandCount = this.changeBandCount.bind(this);
		this.coupledChange = this.coupledChange.bind(this);
	}

	changeBandCount(newValue) {
		const assembly = this.props.shadeAssembly.data();

		const originalBandCount = assembly.band_count ?? assembly.shades.filter((s) => s.row_coordinate == 0).length;

		const { shades } = assembly;

		assembly.band_count = newValue;

		if (originalBandCount > newValue) {
			// Delete bands
			assembly.shades = assembly.shades.filter((s) => s.column_coordinate < newValue);
		} else {
			// Increase bands
			for (let i = originalBandCount; i < newValue; i++) {
				const newShade = { ...shades[0] };
				newShade.width = 0;

				newShade.id = 0;
				newShade.column_coordinate = shades.reduce((s1, s2) => (s1 > s2.column_coordinate ? s1 : s2.column_coordinate), 0) + 1;
				assembly.shades.push(newShade);

				if (assembly.single_dual == "Dual") {
					const dualNewShade = { ...newShade };

					dualNewShade.row_coordinate = 1;
					dualNewShade.fabric_name = assembly.shades.find((s) => s.row_coordinate == 1 && s.column_coordinate == 0).fabric_name;

					assembly.shades.push(dualNewShade);
				}
			}
		}

		assembly.shades.forEach((s) => s.width = 0);

		this.props.option.ValueChanged(assembly.sequence_id, "shades", assembly.shades, this.props.option, true);
		this.props.onChange && this.props.onChange();

		this.props.update();

		this.forceUpdate();
	}

	getIdsByCol(col) {
		const { shadeAssembly } = this.props;

		const shadeIds = shadeAssembly.data().shades.filter((s) => s.column_coordinate == col).map((s) => ({
			sequenceId: shadeAssembly.sequenceId,
			column: s.column_coordinate,
			row: s.row_coordinate
		}));

		return shadeIds;
	}

	coupledChange(Id, dataReference, newValue, col) {
		this.props.widthOption.ValueChanged(Id, dataReference, newValue, col, true);
	}

	render() {
		const shadeItems = [];

		const { disabled } = this.props;

		const { shadeAssembly } = this.props;
		const assemblyId = shadeAssembly.sequence_id;

		const assemblyData = shadeAssembly.data();

		const shades = shadeAssembly.data().shades.filter((s) => s.row_coordinate === 0);

		shades.sort((s1, s2) => s1.column_coordinate - s2.column_coordinate)
			.forEach((s) => {
				shadeItems.push({
					width: s.width,
					column_coordinate: s.column_coordinate,
					row_coordinate: s.row_coordinate,
					assemblyId
				});
			});

		const rows = [];

		let shadeCount = 0;

		let first = true;
		const { quoteType } = this.props;
		const quoteColor = getQuoteColor(quoteType);

		shadeItems.forEach((si) => {
			if (first) {
				first = false;
				rows.push(
					<tr>
						<td style={{
							backgroundColor: quoteColor,
							color: 'white',
							borderRight: '2px solid gray'
						}}
						>
Left Shade
						</td>
						<td>
							<div className="td-couple-shades">
								<OptionField
									disabled={disabled}
									key={`${si.width}-${20}`}
									noLabel
									onChange={this.coupledChange}
									onBlur={this.props.update}
									option={this.props.widthOption}
									value={si.width}
									id={this.getIdsByCol(shadeCount)}
									shade={shadeAssembly}
									isCoupled
								/>
							</div>
						</td>

					</tr>
				);
				shadeCount++;
			} else {
				rows.push(
					<tr>
						<td>
Shade
							{shadeCount + 1}
						</td>
						<td className={`coupled-shades-td ${quoteType}`} style={{ align: 'center' }}>
							<div>
								<OptionField
									disabled={disabled}
									key={`${si.width}-${shadeCount}`}
									noLabel
									onChange={this.coupledChange}
									onBlur={this.props.update}
									option={this.props.widthOption}
									value={si.width}
									id={this.getIdsByCol(shadeCount)}
									shade={shadeAssembly}
									isCoupled
								/>
							</div>
						</td>

					</tr>
				);
				shadeCount++;
			}
		});

		const totalWidth = shadeItems.reduce((s, sn) => s + sn.width, 0);
		const baseBandCount = assemblyData.band_count ?? assemblyData.shades.filter((s) => s.row_coordinate == 0).length;

		/*
        
        */
		return (
			<div
				className="showing-description-modal coupled-table-wrapper"
				style={{
					display: "flex",
					overflow: "hidden",
					flexDirection: "column",
					border: "2px solid grey",
					borderRadius: ".5em",
				}}
			>
				<table
					className="coupled-shades"
					style={{
						width: "100%",
						borderCollapse: "collapse",
						borderRadius: ".25em",
						textAlign: "center",
                    
					}}
				>
					<thead>
						<tr>
							<th style={{ padding: ".5em 2em .5em 2em" }}>
								<div>
Band Count
									<CoupledShadesSelect disabled={disabled} band_count={baseBandCount ?? 1} onChange={this.changeBandCount} />
								</div>
							</th>
							<th>Width</th>
						</tr>
					</thead>
					<tbody style={{
						transform: 'translateY(0px)'
					}}
					>
						{rows}
						<tr>
							<td>Total Calculated Width: </td>
							<td>
								{totalWidth}
								{' '}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

		);
	}
}

class CoupledShadesSelect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			band_count: props.band_count
		};
		this.onChange = this.onChange.bind(this);
	}

	onChange(e) {
		this.props.onChange(parseInt(e.target.value));
	}

	render() {
		const { disabled } = this.props;

		const max = 10;

		const options = [];

		for (let i = 0; i < max; i++) {
			const count = i + 1;

			if (this.props.band_count == count) {
				options.push(<option key={i} value={i + 1} selected>{i + 1}</option>);
			} else {
				options.push(<option key={i} value={i + 1}>{i + 1}</option>);
			}
		}

		return (
			<select disabled={disabled} onChange={this.onChange}>
				{options}
			</select>
		);
	}
}

export default CoupledShadeTable;
